import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { MyFiles } from "@/features/my-files";
import { myFilesSearchSchema } from "@/features/my-files/page-search-schema.ts";
import { usePageTitle } from "@/hooks/usePageTitle";

const templateSearchSchema = myFilesSearchSchema.extend({
  requestType: z.enum(["graphic", "video"]),
});

export const Route = createFileRoute("/_auth/_app-shell/my-files/template")({
  component: function MyFilesTemplateRoute() {
    usePageTitle("My Files");

    return <MyFiles />;
  },
  validateSearch: templateSearchSchema,
});
